import { GiveawayConfigApiClient } from '@fourthwall/services/dist/GiveawayConfigApiClient'
import { createQueryHook } from '@fourthwall/utils'

export const useGiveawayConfigOAuthConnectionsQuery = createQueryHook(
  GiveawayConfigApiClient.getGiveawayConfigOAuthConnections,
  {
    queryKey: ['giveawayConfigOAuthConnections'],
  },
)
